export const imagesExtension = ['png', 'jpg', 'jpeg'];
export const videosExtension = ['mp4', 'mov'];
export const soundsExtension = ['mp3'];

export const isImageMedia = (media) => imagesExtension.some((imageExtension) => media?.url?.endsWith(imageExtension));

export const isVideoMedia = (media) => videosExtension.some((videoExtension) => media?.url?.endsWith(videoExtension));

export const isSoundMedia = (media) => soundsExtension.some((soundExtension) => media?.url?.endsWith(soundExtension));
